import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["width", "height"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import IconBase from './IconBase';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ArrowRight = function ArrowRight(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 15 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 12 : _ref$height,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs(IconBase, _objectSpread(_objectSpread({
    $styles: {
      width: width,
      height: height
    },
    viewBox: "0 0 15 12"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      width: 13,
      height: 2,
      rx: 1,
      transform: "matrix(-1 0 0 1 13 5)",
      fill: "#fff"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8 1l5 5-5 5",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "round"
    })]
  }));
};

export default ArrowRight;